(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ComercioDialogController', ComercioDialogController);

    ComercioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Comercio', 'Pv', 'Aeropuerto', 'Rubro',  'Moneda' ];

    function ComercioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comercio, Pv, Aeropuerto, Rubro, Moneda) {
        var vm = this;

        vm.comercio = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pvs = Pv.query();
        vm.aeropuertos = Aeropuerto.query();
        vm.rubros = Rubro.query();
        vm.monedas = Moneda.query();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.comercio.id !== null) {
                Comercio.update(vm.comercio, onSaveSuccess, onSaveError);
            } else {
                Comercio.save(vm.comercio, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:comercioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
